// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"e9e682e4a4954ab8f485","339":"20f0e2271109bbc1687a"}[chunkId] + ".js";
};